// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flag[data-v-6e41a3b8]{float:left;text-align:middle;margin-right:10px}.locale-container[data-v-6e41a3b8]{text-align:left;cursor:pointer}.menu[data-v-6e41a3b8]{background:rgba(0,0,0,.4)}.menu-button[data-v-6e41a3b8]{text-transform:inherit}.menu-button i[data-v-6e41a3b8]{color:inherit}.menu-item[data-v-6e41a3b8]:hover{background:rgba(255,193,34,.4)}.menu-title[data-v-6e41a3b8]{color:#fff;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
